import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  const navLinks = [
    { key: "nav.top", path: "/" },
    { key: "nav.service", path: "/service" },
    { key: "nav.system", path: "/system" },
    { key: "nav.flow", path: "/introduction-flow" },
    { key: "nav.about", path: "/about" },
    { key: "nav.contact", path: "/contact" },
  ];

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-8">
        {/* Top grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-12 border-b border-slate-700/50">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/9051b913-a4fc-49c8-8d5f-b0cc0fd3b0da.png"
              alt="Stream Solutions Limited"
              className="h-10 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              {t("footer.tagline")}
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full border border-slate-600 text-slate-400 hover:border-cyan-500 hover:text-cyan-400 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-linkedin-line text-sm" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center rounded-full border border-slate-600 text-slate-400 hover:border-cyan-500 hover:text-cyan-400 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-twitter-x-line text-sm" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest text-slate-400 uppercase mb-5">
              {t("footer.nav")}
            </h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.key}>
                  <Link
                    to={link.path}
                    className="text-sm text-slate-300 hover:text-cyan-400 transition-colors duration-200 cursor-pointer underline-offset-2 hover:underline"
                  >
                    {t(link.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold tracking-widest text-slate-400 uppercase mb-5">
              {t("footer.contact_info")}
            </h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-cyan-400 text-sm" />
                </div>
                <a
                  href="tel:+85253213455"
                  className="text-sm text-slate-300 hover:text-cyan-400 transition-colors duration-200 cursor-pointer"
                >
                  {t("footer.tel")}
                </a>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-cyan-400 text-sm" />
                </div>
                <div className="text-sm text-slate-300 leading-relaxed">
                  <p>{t("footer.address.en")}</p>
                  <p className="mt-1 text-slate-400">{t("footer.address.ja")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">{t("footer.copyright")}</p>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy"
              className="text-xs text-slate-500 hover:text-cyan-400 transition-colors duration-200 cursor-pointer"
            >
              {t("footer.privacy")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
